export default __webpack_public_path__ + "static/media/regulatory--cyclists-dismount-and-walk--g1.85523214.png";